import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import DroppableComDown from "../DroppableComDown.jsx";
import DroppableComUp from "../DroppableComUp.jsx";
import { isMobile } from "@/utils/common";
import * as _ from "lodash";
import {gradient} from "@/utils/colorCacl";

export default function Drag(props) {
  const [data, setData] = useState({});
  const [aa, update] = useState({});
  const [_colors, setcolors] = useState([])

  const { info = {}, answer = {}, changeAnswer } = props;
  const [selctListObj, setSelctListObj] = useState([]);
  useEffect(() => {
    props.info.childs.map((item) => {
      item.selctData = [];
    });
    props.info.options.map(
      (item) => (item.childs = JSON.parse(JSON.stringify(props.info.childs)))
    );

    // setPostData(answer);
    setData(props.info);
  }, []);
  useEffect(() => {
    setcolors(gradient("#010000", "#dc2f20", data?.options?.filter((item) => {
      return item?.hide !== 1;
    }).length || 1))
  }, [data])

  const historyAnswer = () => {
    const id2Code = (id) => {
      let result = "";
      data.childs.map((question) => {
        question.options.map((option) => {
          if (option.id === id) {
            result = option.codeValue;
          }
        });
      });

      return result;
    };

    try {
      const answerObj = answer[info.id];
      const qustionIds = Object.keys(answerObj);
      let newInfochilds = data.childs;
      let answerHis = answer[info.id] || {};

      let selctCode = [];
      newInfochilds.forEach((item) => {
        if (answerHis[item.id]) {
          selctCode.push(item.codeValue + "");
        }
      });
      setSelctListObj(selctCode);
      for (let i = 0; i < qustionIds.length; i++) {
        const qId = qustionIds[i];
        const optObj = answerObj[qId];
        const optionIds = Object.keys(optObj);
        for (let j = 0; j < optionIds.length; j++) {
          const optId = optionIds[j];
          const code = id2Code(optId);
          data.options.map((option) => {
            if (option.codeValue === code) {
              option.childs.map((question) => {
                question.options.map((opt) => {
                  if (question.id === qId) {
                    question.dragShow = true;
                  }
                });
              });
            }
          });
        }
      }
      setData(data);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    historyAnswer();
  }, [answer]);
  const arrMove = (array, first, second) => {
    var tmp = array[second];
    array[second] = array[first];
    array[first] = tmp;
    return array;
  };

  // 同一个区域托 j交换
  const sameDrag = (result) => {
    const { source, destination } = result;

    let idList = data.options.map((item) => item.id);
    if (
      idList.includes(destination.droppableId) &&
      idList.includes(source.droppableId)
    ) {
      // sameDragDown(result);
    } else {
      data.childs = arrMove(data.childs, source.index, destination.index);
    }
  };

  const commitData = () => {
    let obj = {};
    let selctShow = {};

    data.options.forEach((item) => {
      item.childs.forEach((item2) => {
        let id = item2.options.find(
          (item3) => item.codeValue == item3.codeValue
        ).id;
        if (item2.dragShow) {
          selctShow[item2.codeValue] = null;
          obj[item2.id] = { ...obj[item2.id], [id]: null };
        }
      });
    });
    setSelctListObj(Object.keys(selctShow));
    changeAnswer(obj);
  };
  const onBeforeDragStart = (ee) => {
    sessionStorage.setItem("draggableId", ee.draggableId);
    /*...*/
  };
  const onDragEnd = (result) => {
    // source移动   ==》 destination 目标
    const { source, destination } = result;
    if (!destination) {
      return;
    }

    //   options 作为选项
    if (source.droppableId === destination.droppableId) {
      sameDrag(result);
    } else {
      let optionslist = data.options.map((item) => item.id);
      // 上下移动 optionslist 标识
      if (
        optionslist.includes(source.droppableId) &&
        optionslist.includes(destination.droppableId)
      ) {
        let findDsource = data.options.find(
          (item) => item.id == source.droppableId
        );

        let findDdestination = data.options.find(
          (item) => item.id == destination.droppableId
        );
        //获取 拖动的数据
        findDdestination.childs.find((item) => {
          if (item.codeValue == result.draggableId.split("|")[0]) {
            item.dragShow = true;
          }
        });
        findDsource.childs[source.index].dragShow = false;
      } else {
        let destinationObj = data.options.find(
          (item) => item.id == destination.droppableId
        );
        if (destinationObj) {
          destinationObj.childs.forEach((item2) => {
            if (item2.codeValue == result.draggableId) {
              item2.dragShow = true;
            }
          });
        } else {
          let sourceObj = data.options.find(
            (item) => item.id == source.droppableId
          );
          sourceObj.childs[source.index].dragShow = false;
        }
      }
    }
    commitData();
  };

  const [eleWidth,setEleWidth] = useState(null);
  const [arrMaxLength,setArrMaxLength] = useState(1);
  const [itemMaxWidth,setItemMaxWidth] = useState("");
  const titleTbleInvisiable = (options,id) => {
    let _options = [];
    if (options) {
      _options = options.filter((item) => {
        return item.hide !== 1;
      });
    }
    return (
        <div id={`titleTbleReference-${id}`} style={{display: "flex", background: "#ccc",position:'absolute',width:eleWidth||"100px",visibility:'hidden'}}>
          {(_options || []).map((item1, index) => (
              <div
                  key={item1?.id}
                  style={{
                    border: "1px solid #ccc",
                    background: "rgb(204, 204, 204)",
                    borderRight: "1px solid #fff",
                    textAlign: "center",
                    flex:1
                  }}
              >
                <div dangerouslySetInnerHTML={{__html: imgSetStyle(item1?.description)}}></div>
                {/* 下面块区域 */}
              </div>
          ))}
        </div>
    );
  };
  const imgSetStyle=(htmlText)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    // 查找 <img> 标签并修改属性
    const img = doc.querySelector('img');
    if (img) {
      img.setAttribute('width','none')
      img.setAttribute('height','none')
      img.setAttribute('style', 'max-width: 100%;object-fit: contain;max-height:60px;height:100%'); // 修改样式
    }
    return doc.body.innerHTML
  }
  useEffect(()=>{
    if (!(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)){
      return
    }
      let ele=document.getElementById("titleTbleWidthReference")
      const observer = new ResizeObserver(() => {
        // 更新元素高度
        setEleWidth(ele.offsetWidth+'px');
      });

      // 开始观察元素
      observer.observe(ele);

      // 清理函数：在组件卸载时停止观察
      return () => {
        observer.disconnect();
      };

  },[])
  useEffect(()=>{
    let temparr = [data.options];
    if (col && isMobile) {
      temparr = _.chunk(data.options || [], +col);

    }
    setArrMaxLength(Math.max(...temparr.map(item=>(item||[]).length))||1)
  },[data.options])
  useEffect(()=>{
    setItemMaxWidth((((((eleWidth?eleWidth.replace("px",""):100)||100)/(arrMaxLength||1))||100)-33)+'px')
    console.log("width:"+itemMaxWidth)
  },[eleWidth,arrMaxLength])

  const col = info.preferences?.optionPrefer?.optionsColumns;
  let arr = [data.options];
  let _colorsIndex = 0
  if (col && isMobile) {
    arr = _.chunk(data.options || [], +col);
  }
  let paishu=0

  return (
      <DragDropContext
          onDragEnd={onDragEnd}
          onBeforeDragStart={onBeforeDragStart}
      >
        {/* 上面拖拖动区域 */}
        <DroppableComUp
            direction={0}
            item1={data}
            selctListObj={selctListObj}
            update={update}
        />
        <div style={{width: '100%'}} id="titleTbleWidthReference"></div>
        {arr.map((data) => {
          paishu++;
          return (
              <>
                {/*{info.preferences?.childPrefer?.optionForm == 5 && titleTble(data)}*/}
                {(info.preferences?.childPrefer?.optionForm === 6||info.preferences?.childPrefer?.optionForm ===5)&&titleTbleInvisiable(data || [], paishu)}
                <div style={{display: 'flex', alignItems: 'stretch'}}>
                  <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
                    <div style={{display: "flex", flex: 'auto'}}>
                      {/* 中间头信息移动至每个框上方以适应换行 */}
                      {(data || []).map((item1, index) => (
                          <div style={
                            {
                              flexWrap: "wrap",
                              flexDirection: "column",
                              flex: 1,
                              display: 'flex'
                            }
                          }>
                            <div
                                style={info.preferences?.childPrefer?.optionForm == 6 ? {backgroundImage: `linear-gradient(to right,${_colors[_colorsIndex]},${_colors[++_colorsIndex]})`,} : {display: 'none'}}>
                              &nbsp;
                            </div>
                            <DroppableComDown direction={0} item1={item1}
                                              optionForm={info.preferences?.childPrefer?.optionForm}
                                              titleTbleData={data[index]} col={paishu}
                                              maxItemHeight={itemMaxWidth}
                            />
                          </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/*{info.preferences?.childPrefer?.optionForm == 6 && titleTble(data)}*/}
              </>
          );
        })}
      </DragDropContext>
  );
}
